import { getCourseInstancePath } from 'components/dashboard/ClassCard/helpers'

export function courseSelectHandlerFactory(productName, navigationEvent) {
  return course => () =>
    navigationEvent(`/product/${productName}/lessons/preview/${course}`)
}

export function classSelectHandlerFactory(productName, navigationEvent) {
  return (course, instance) => () => {
    // Check if this is a K8 product (elementary or middle-school)
    const isK8Product =
      productName === 'elementary' || productName === 'middle-school'

    if (isK8Product) {
      // Use the helper function for K8 products to get the correct path with /unit-1 and goToNextUnit=true
      const path = getCourseInstancePath({
        program: productName,
        gradeDisplayTitle: course,
        instance: instance,
        tier: 1,
      })
      navigationEvent(path)
    } else {
      // Keep existing behavior for non-K8 products
      navigationEvent(
        `/product/${productName}/lessons/teach/${course}?class=${instance}`,
      )
    }
  }
}
export function gotoDashboardHandlerFactory(navigationEvent) {
  return () => navigationEvent('/')
}
